import { Component, OnInit, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { AccordionModule } from 'primeng/accordion';
import { SkeletonModule } from 'primeng/skeleton';
import { MessageModule } from 'primeng/message';
import { ProjectsService, Project } from '../../services/projects.service';

@Component({
  selector: 'app-investment',
  standalone: true,
  imports: [
    CommonModule,
    ButtonModule,
    AccordionModule,
    SkeletonModule,
    MessageModule
  ],
  templateUrl: './investment.component.html',
  styleUrls: ['./investment.component.scss']
})
export class InvestmentComponent implements OnInit {
  private projectsService = inject(ProjectsService);

  projects = signal<Project[]>([]);
  isLoading = signal<boolean>(false);
  errorMessage = signal<string>('');

  ngOnInit() {
    this.loadProjects();
  }

  loadProjects() {
    this.isLoading.set(true);
    this.errorMessage.set('');

    this.projectsService.getProjects().subscribe({
      next: (projects) => {
        this.projects.set(projects);
        this.isLoading.set(false);
      },
      error: (error) => {
        console.error('Error loading projects:', error);
        this.errorMessage.set('Erreur lors du chargement des projets');
        this.isLoading.set(false);
      }
    });
  }

  goToDiscord() {
    window.open('https://discord.gg/', '_blank');
  }

  formatDate(dateString: string): string {
    return new Date(dateString).toLocaleDateString('fr-FR', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  }
  trackByProjectId(index: number, project: Project): string {
    return project.id;
  }

  contactSupport(project: Project) {
      const subject = `Support request: ${project.name}`;
  const body = [
    'Hello Coteo Support,',
    '',
    'I am interested about this project:',
    `• Title: ${project.name}`,
    `• Description: ${project.description ?? 'N/A'}`,
    `• Project ID: ${project.id ?? 'N/A'}`,
    '',
    'Thanks,',

  ].join('\n');

  const mailto = `mailto:support@analytix.com?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  window.location.href = mailto; 

  }
}